import { IUserData } from 'components/UserExtraValues'
import { filterString } from './cleanup'

export const formatUserData = (userData: IUserData) => {
  const returnedUserData = {
    cpf: filterString(userData.cpf.value, ['.', '-']),
    ...(userData.zip_code && {
      address: {
        number: userData.number?.value,
        state: userData.state?.value,
        zip_code: filterString(userData.zip_code.value, ['-', '.']),
        street: userData.street?.value,
        city: userData.city?.value,
        complement: userData.complement?.value || '-',
        neighbourhood: userData.neighbourhood?.value,
      },
    }),
  }

  return returnedUserData
}
